/*
 * <playbook-modal> — lightweight gate modal for the playbook landing page.
 * Opens from any [data-playbook-open] button on the page (the top and bottom
 * "Send me the free playbook" CTAs both work). Closes on overlay click or Escape.
 * Auto-opens when the customer form comes back with validation errors so the
 * visitor sees what to fix.
 */
class PlaybookModal extends HTMLElement {
  constructor() {
    super();
    this.overlay = this.querySelector('[data-playbook-overlay]');
    this.dialog = this.querySelector('[data-playbook-dialog]');
    this.closeButtons = this.querySelectorAll('[data-playbook-close]');

    this.onKeyup = this.onKeyup.bind(this);

    // Wire every open trigger on the page.
    document.querySelectorAll('[data-playbook-open]').forEach((trigger) => {
      trigger.addEventListener('click', (event) => {
        event.preventDefault();
        this.open();
      });
    });

    this.closeButtons.forEach((btn) => btn.addEventListener('click', () => this.close()));
    if (this.overlay) {
      this.overlay.addEventListener('click', () => this.close());
    }

    // Reopen automatically if the form posted with errors.
    if (this.hasAttribute('data-open-on-load')) {
      this.open();
    }
  }

  open() {
    this.setAttribute('open', '');
    document.body.classList.add('overflow-hidden');
    document.addEventListener('keyup', this.onKeyup);
    const firstField = this.querySelector('input:not([type="hidden"])');
    if (firstField) firstField.focus();
  }

  close() {
    this.removeAttribute('open');
    document.body.classList.remove('overflow-hidden');
    document.removeEventListener('keyup', this.onKeyup);
  }

  onKeyup(event) {
    if (event.code && event.code.toUpperCase() === 'ESCAPE') this.close();
  }
}

if (!customElements.get('playbook-modal')) {
  customElements.define('playbook-modal', PlaybookModal);
}
